export const filter = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.25 14a8.75 8.75 0 1 1 17.5 0 8.75 8.75 0 0 1-17.5 0ZM14 3.25C8.063 3.25 3.25 8.063 3.25 14S8.063 24.75 14 24.75 24.75 19.937 24.75 14 19.937 3.25 14 3.25ZM20 10v2H8v-2h12ZM9.5 13.75v2h9v-2h-9ZM11 17.5v2h6v-2h-6Z"
    fill="currentColor"
  />
);
